import React, { useCallback } from 'react'
import Screen from '../../../../components/molecules/screen/Screen'
import Button from '../../../../components/atoms/button/Button'
import styles from './WelcomeRegisterScreen.module.css'
import { useNavigate } from 'react-router-dom'
import Text from '../../../../components/atoms/text/Text'
import routes from '../../../../config/routes'
import { ReactComponent as WelcomeIllustration } from './assets/welcome_illustration.svg'
import { VARIANTS } from '../../../../types/Components.types'

const WelcomeRegisterScreen = () => {
  const navigate = useNavigate()

  const goToRegister = useCallback(() => {
    navigate(routes.register, { replace: true })
  }, [navigate])

  return (
    <Screen hasDecorator decoratorSize="large">
      <div className={styles.container}>
        <div className={styles.content}>
          <WelcomeIllustration className={styles.illustration} />

          <Text size="l" variant={VARIANTS.primary} weight="700" align="center" className={styles.title}>
            Bienvenido al coworking de San Lorenzo del Escorial
          </Text>

          <Text align="center">Tu nuevo espacio de trabajo</Text>
        </div>

        <Button variant={VARIANTS.primary} className={styles.action} onClick={goToRegister}>
          ¡Vamos!
        </Button>
      </div>
    </Screen>
  )
}

export default React.memo(WelcomeRegisterScreen)
